/**
 * Returns the first argument it receives.
 *
 * @internal
 */
export function identityFunc<T>(x: T): T {
  return x;
}
